import { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// material
// import { useTheme } from '@mui/material/styles';
// import { Container, Box } from '@mui/material';
import { Input } from 'src/@/components/ui/input'
import { Button } from 'src/@/components/ui/button'
import { Switch } from 'src/@/components/ui/switch'
import { Textarea } from 'src/@/components/ui/textarea'

import { useSnackbar } from 'notistack';
import useAuth from 'src/hooks/useAuth';

import { HeaderPageComponentConfig } from 'src/components/_dashboard/configuracoes';
import Iconify from "src/components/Iconify";

export default function EditarProduto() {
    const { cliente } = useAuth()
    const navigate = useNavigate();
    const location = useLocation();
    let path = location.pathname.substring(1); // Remove o "/" inicial


    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get('id');

    }, [location]);


    const [produto, setProduto] = useState({
        _id: '',
        loja: 98,
        codigo: 570647,
        descricao: '121100 SAP SLIP ON M PEGADA 140708 139356',
        tamanho: '35',
        referencia: '140708',
        ultimaCompra: '',
        ncm: '64039990',
        unidade: null,
        ativo: 1,
        codigo_linx: '139356',
        tipo: {
            loja: 98,
            codigo: 18,
            descricao: 'SAPATO CASUAL SEM CADARCO MASCULINO'
        },
        marca: {
            loja: 98,
            codigo: 172,
            descricao: 'PEGADA'
        },
        cores: [
            { loja: 98, codigo: 10070, descricao: '06-NOBUCK MARINHO' },
            { loja: 98, codigo: 1, descricao: 'BRANCO' }
        ],
        departamento: {
            loja: 98,
            codigo: 6,
            descricao: 'MASCULINO'
        },
        classe: {
            loja: 98,
            codigo: 18,
            descricao: 'SAPATO'
        },
        colecao: {
            loja: 98,
            codigo: 2,
            descricao: 'PERMANENTE'
        },
        modelo: {
            loja: 98,
            codigo: 8,
            descricao: 'SAPATILHA'
        },
        codigoBarra: '',
        cest: '',
        sitTributariaIpi: '99',
        sitTributariaPis: '01',
        sitTributariaCofins: '01',
        consignado: false,
        multiplosCodigoBarra: [],
        data_insert: '',
        __v: 0,
        custoMedios: [],
        fornecedor: {
            loja: 1,
            razao: 'CALCADOS PEGADA NORDESTE LTDA',
            codigo: 5825,
            nome: 'PEGADA - 0802'
        },
        link: ''
    });

    // Mock de imagens já existentes (substitua por dados reais se necessário)
    const [imagensExistentes, setImagensExistentes] = useState([
        // Exemplo: URLs de imagens já salvas
        // 'https://via.placeholder.com/150',
    ]);
    const [imagens, setImagens] = useState([]);
    const [previews, setPreviews] = useState([]);

    const dropRef = useRef();
    const [isDragging, setIsDragging] = useState(false);

    // Para ordenação de imagens
    const [draggedIdx, setDraggedIdx] = useState(null);
    const allImagesWithType = [
        ...imagensExistentes.map((src, idx) => ({ src, tipo: 'existente', idx })),
        ...previews.map((src, idx) => ({ src, tipo: 'preview', idx }))
    ];

    const handleDragStart = (idx) => setDraggedIdx(idx);
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };
    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };
    const handleDrop = (idx) => {
        if (draggedIdx === null || draggedIdx === idx) return;
        const arr = [...allImagesWithType];
        const [removed] = arr.splice(draggedIdx, 1);
        arr.splice(idx, 0, removed);
        // Separar de volta em existentes e previews
        const novasExistentes = arr.filter(img => img.tipo === 'existente').map(img => img.src);
        const novasPreviews = arr.filter(img => img.tipo === 'preview').map(img => img.src);
        setImagensExistentes(novasExistentes);
        // Reordenar também os arquivos de imagens e previews
        const novasImagens = novasPreviews.map(src => {
            const idxPreview = previews.indexOf(src);
            return imagens[idxPreview];
        });
        setImagens(novasImagens);
        setPreviews(novasPreviews);
        setDraggedIdx(null);
    };

    // Atualiza previews ao selecionar novas imagens
    const handleImagensChange = (e) => {
        const files = Array.from(e.target.files).slice(0, 5 - imagensExistentes.length);
        setImagens(files);
        const newPreviews = files.map(file => URL.createObjectURL(file));
        setPreviews(newPreviews);
    };

    // Remove imagem nova
    const removePreview = (idx) => {
        const newImgs = imagens.filter((_, i) => i !== idx);
        const newPrevs = previews.filter((_, i) => i !== idx);
        setImagens(newImgs);
        setPreviews(newPrevs);
    };

    // Remove imagem existente
    const removeExistente = (idx) => {
        setImagensExistentes(imagensExistentes.filter((_, i) => i !== idx));
    };

    // Carrossel simples
    const [imgIndex, setImgIndex] = useState(0);
    const allImages = [...imagensExistentes, ...previews];
    const nextImg = () => setImgIndex((prev) => (prev + 1) % allImages.length);
    const prevImg = () => setImgIndex((prev) => (prev - 1 + allImages.length) % allImages.length);

    // Carrossel: navegação por teclado
    useEffect(() => {
        const handleKey = (e) => {
            if (allImages.length === 0) return;
            if (e.key === 'ArrowLeft') prevImg();
            if (e.key === 'ArrowRight') nextImg();
        };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [allImages.length, imgIndex]);

    // Estado do status ativo
    const [statusAtivo, setStatusAtivo] = useState(produto.ativo === 1);

    // Handlers dos botões
    const handleSalvar = () => {
        // lógica para salvar as alterações
    };
    const handleExcluir = () => {
        // lógica para excluir o produto
    };
    const handleStatusChange = (checked) => {
        setStatusAtivo(checked);
        setProduto({ ...produto, ativo: checked ? 1 : 0 });
    };

    return (
        <div className=''>
            <div className="container">
                {/* Header customizado */}
                <div className="flex justify-between items-center border-b border-slate-100 pb-4 mb-4">
                    <div className="flex items-center gap-3">
                        <Button size="icon" variant="ghost" onClick={() => navigate('/dashboard/configuracoes/integracoes')}>
                            <Iconify icon={'material-symbols:arrow-back-ios'} />
                        </Button>
                        <div>
                            <h4 className="scroll-m-20 text-xl font-semibold tracking-tight">Editar Produto</h4>
                            <p className="text-xs leading-7">Edite as informações do produto</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="flex items-center gap-2">
                            <span className="text-xs text-gray-600">Ativo</span>
                            <Switch checked={statusAtivo} onCheckedChange={handleStatusChange} />
                        </div>
                        <Button variant="destructive" onClick={handleExcluir} size="sm">
                            <Iconify icon="material-symbols:delete-outline" className="mr-1" /> Excluir
                        </Button>
                        <Button variant="default" onClick={handleSalvar} size="sm">
                            <Iconify icon="material-symbols:save" className="mr-1" /> Salvar
                        </Button>
                    </div>
                </div>
                <div className='flex flex-col gap-6 mt-2 max-h-[70vh] overflow-y-auto pr-2'>

                    {/* Primeira linha: Código, Referência, Tamanho, NCM */}
                    <div className="flex gap-4 mb-4">
                        <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700">Código:</label>
                            <Input type="text" value={produto.codigo} readOnly className="mt-1 block w-full" />
                        </div>
                        <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700">Referência:</label>
                            <Input type="text" value={produto.referencia} onChange={(e) => setProduto({ ...produto, referencia: e.target.value })} className="mt-1 block w-full" />
                        </div>
                        <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700">Tamanho:</label>
                            <Input type="text" value={produto.tamanho} onChange={(e) => setProduto({ ...produto, tamanho: e.target.value })} className="mt-1 block w-full" />
                        </div>

                    </div>

                    {/* Terceira linha: Tipo, Marca, Departamento, Classe */}
                    <div className="flex gap-4 mb-4">
                        <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700">Linha:</label>
                            <Input type="text" value={produto.tipo.descricao} onChange={(e) => setProduto({ ...produto, tipo: { ...produto.tipo, descricao: e.target.value } })} className="mt-1 block w-full" />
                        </div>
                        <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700">Marca:</label>
                            <Input type="text" value={produto.marca.descricao} onChange={(e) => setProduto({ ...produto, marca: { ...produto.marca, descricao: e.target.value } })} className="mt-1 block w-full" />
                        </div>
                        <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700">Departamento:</label>
                            <Input type="text" value={produto.departamento.descricao} onChange={(e) => setProduto({ ...produto, departamento: { ...produto.departamento, descricao: e.target.value } })} className="mt-1 block w-full" />
                        </div>
                        <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700">Classe:</label>
                            <Input type="text" value={produto.classe.descricao} onChange={(e) => setProduto({ ...produto, classe: { ...produto.classe, descricao: e.target.value } })} className="mt-1 block w-full" />
                        </div>
                    </div>
                    {/* Quarta linha: Coleção, Modelo, Código de Barras, CEST */}
                    <div className="flex gap-4 mb-4">
                        <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700">Coleção:</label>
                            <Input type="text" value={produto.colecao.descricao} onChange={(e) => setProduto({ ...produto, colecao: { ...produto.colecao, descricao: e.target.value } })} className="mt-1 block w-full" />
                        </div>
                        <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700">Modelo:</label>
                            <Input type="text" value={produto.modelo.descricao} onChange={(e) => setProduto({ ...produto, modelo: { ...produto.modelo, descricao: e.target.value } })} className="mt-1 block w-full" />
                        </div>

                    </div>
                    {/* Campo Link */}
                    <div className="flex gap-4 mb-4">
                        <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700">Link do Produto:</label>
                            <Input type="url" value={produto.link} onChange={(e) => setProduto({ ...produto, link: e.target.value })} placeholder="https://exemplo.com/produto" className="mt-1 block w-full" />
                        </div>
                    </div>


                    {/* Card de upload e visualização de imagens */}
                    <div className="flex flex-col gap-2 mb-4 bg-white rounded-lg shadow p-4 border border-gray-200">
                        <div className="mb-2 flex items-center gap-2">
                            <span className="text-base font-semibold text-gray-800">Fotos do Produto</span>
                        </div>
                        <p className="text-xs text-gray-500 mb-2">Arraste até 5 imagens ou clique para selecionar. Apenas arquivos de imagem são aceitos.<br />Arraste as miniaturas para ordenar.</p>
                        {/* Dropzone */}
                        <div
                            ref={dropRef}
                            tabIndex={0}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            onClick={() => dropRef.current.querySelector('input[type=file]').click()}
                            className={`flex flex-col items-center justify-center border-2 border-dashed rounded-lg p-4 cursor-pointer transition ${isDragging ? 'border-violet-500 bg-violet-50' : 'border-gray-300 bg-gray-50'} ${imagensExistentes.length + imagens.length >= 5 ? 'opacity-60 cursor-not-allowed' : ''}`}
                        >
                            <svg width="32" height="32" fill="none" className="mb-2 text-violet-400"><path d="M16 4v16m0 0l-6-6m6 6l6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><rect x="4" y="20" width="24" height="4" rx="2" fill="currentColor" opacity=".1" /></svg>
                            <span className="text-sm text-gray-600">{imagensExistentes.length + imagens.length < 5 ? 'Clique ou arraste para adicionar' : 'Limite de 5 imagens atingido'}</span>
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                disabled={imagensExistentes.length + imagens.length >= 5}
                                onChange={handleImagensChange}
                                className="hidden"
                                tabIndex={-1}
                            />
                        </div>
                        <div className="flex flex-wrap gap-4 mt-4">
                            {allImagesWithType.map((img, idx) => (
                                <div
                                    key={img.src + idx}
                                    className="relative group"
                                    draggable
                                    onDragStart={() => handleDragStart(idx)}
                                    onDragOver={handleDragOver}
                                    onDrop={() => handleDrop(idx)}
                                    style={{ opacity: draggedIdx === idx ? 0.5 : 1, cursor: 'grab' }}
                                >
                                    <img src={img.src} alt={`Imagem ${idx + 1}`} className="h-24 w-24 object-cover rounded border" />
                                    {img.tipo === 'existente' ? (
                                        <button
                                            type="button"
                                            onClick={() => removeExistente(img.idx)}
                                            className="absolute top-1 right-1 bg-white/80 rounded-full p-1 shadow hover:bg-red-100 text-red-600 group-hover:opacity-100 opacity-80 transition"
                                            title="Remover imagem"
                                        >
                                            <span className="sr-only">Remover imagem</span>&times;
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            onClick={() => removePreview(img.idx)}
                                            className="absolute top-1 right-1 bg-white/80 rounded-full p-1 shadow hover:bg-red-100 text-red-600 group-hover:opacity-100 opacity-80 transition"
                                            title="Remover imagem"
                                        >
                                            <span className="sr-only">Remover imagem</span>&times;
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
